import React from "react";
import { Pie } from "react-chartjs-2";
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
  Title,
} from "chart.js";

// Register the necessary components
ChartJS.register(ArcElement, Tooltip, Legend, Title);

const PieChart = ({ presetPercentage = 0, absentPercentage = 0 }) => {
  // Check if the data is valid (optional)
  if (presetPercentage === undefined || absentPercentage === undefined) {
    console.error("Missing data for PieChart props.");
  }

  // Ensure that the sum of Present and Absent doesn't exceed 100
  const totalPercentage = presetPercentage + absentPercentage;
  if (totalPercentage > 100) {
    console.error("The sum of Present and Absent percentages cannot exceed 100.");
    return null;
  }

  // Data for the pie chart
  const data = {
    labels: [
      `Present: ${presetPercentage}%`, 
      `Absent: ${absentPercentage}%`, 
      `Total: 100%` // This shows the total as 100%
    ],
    datasets: [
      {
        label: "Attendance", // Update this label for context
        data: [
          presetPercentage, 
          absentPercentage, 
          100 - totalPercentage // Calculate the remaining portion to fill the 100%
        ], 
        backgroundColor: [
          "#1976d2",   // Present
          "#e5e5e5",     // Absent
          "gray", // Filler section to make it sum to 100%
        ],
        borderWidth: 1,
      },
    ],
  };

  // Options for the pie chart
  const options = {
    plugins: {
      tooltip: {
        bodyFont: {
          size: 14,
        },
      },
      legend: {
        labels: {
          font: {
            size: 10,  // Smaller font size for the legend labels
          },
        },
      },
    },
    responsive: true,
    maintainAspectRatio: false,
  };

  return (
    <div style={{ width: "100%", height: "100%", marginLeft: "auto", marginRight: "auto" }}>
      <Pie data={data} options={options} />
    </div>
  );
};

export default PieChart;
